import { useSnapshot } from 'valtio'
import cn from 'classnames'
import { type ReactElement } from 'react'
import { APP_PATH } from '../../../../pages/app'
import { proxyGlobalAuth } from '../../../proxies/proxyGlobalAuth'
import { globalMerchantsProxy } from '../../../proxies/globalMerchantsProxy'
import { type BreadcrumbNodeType } from './BreadcrumbsUtils'

interface BreadcrumbsProps {
  breadcrumbs: BreadcrumbNodeType[]
}

export default function Breadcrumbs ({ breadcrumbs }: BreadcrumbsProps): ReactElement {
  const { siteTheme: { breadcrumbs: breadCrumbTheme } } = useSnapshot(proxyGlobalAuth)

  const { selectedMerchant } = useSnapshot(globalMerchantsProxy)

  return (
    <div className="text-xl font-semibold w-3/4 tracking-wide opacity-90">
      <a className={breadCrumbTheme.classes} href={APP_PATH}>
        {selectedMerchant?.merchantName}
      </a>
      {breadcrumbs.map((breadcrumb) => (
        <span key={breadcrumb.text}>
          <span className={cn(breadCrumbTheme.endText, 'mx-2')}>/</span>
          {
            breadcrumb.path
              ? (
                <a className={breadCrumbTheme.classes} href={breadcrumb.path}>
                  {breadcrumb.text}
                </a>
                )
              : (
                <span className={breadCrumbTheme.endText}>
                  {breadcrumb.text}
                </span>
                )
          }
        </span>
      ))}
    </div>
  )
}
